import React from 'react';
import {
    ListButton,
    SaveButton,
    SimpleForm as RaSimpleForm,
    Toolbar as RaToolbar,
} from 'react-admin';

const Toolbar = ({ resource }: { resource: string }) => {
    return (
        <RaToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            <SaveButton />
            <ListButton resource={resource} sx={{ marginLeft: 2 }} />
        </RaToolbar>
    );
};

export const GenerateForm = ({
    children,
    ...props
}: {
    children: React.ReactNode;
    resource: string;
    [key: string]: unknown;
}) => {
    const { resource } = props;
    return (
        <RaSimpleForm
            {...props}
            sanitizeEmptyValues
            toolbar={<Toolbar resource={resource} />}
        >
            {children}
        </RaSimpleForm>
    );
};
